import React from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'

const MeterTabs = ({
  NavLink,
  items = [],
  navClassName = '',
  breakpoint = 'lg',
  rules = []
}) => (
  <div className='row mb-4'>
    <div className={`col-12 d-none d-${breakpoint}-block`}>
      <Nav className='meter-nav flex-column'>
        {items.filter((d) => !rules.length || !d.perform || (d.perform && rules.includes(d.perform))).map((d, i) => (
          d && (
            <Nav.Item key={i} bsPrefix={`nav-item ${navClassName}`}>
              <NavLink className={({ isActive }) => `nav-link meter-link text-start ${isActive ? ' active' : ''} ps-2`} to={d.path}>
                {
                  d.component
                    ? d.component
                    : <div className='tab-title'><span style={{ minWidth: '21px' }} className={`tab-icon fa-solid fa-${d.icon} me-2`} />{d.title}</div>
                }
              </NavLink>
            </Nav.Item>
          )
        ))}
      </Nav>
    </div>
  </div>
)

MeterTabs.propTypes = {
  NavLink: PropTypes.elementType.isRequired,
  items: PropTypes.array,
  navClassName: PropTypes.string,
  breakpoint: PropTypes.string,
  rules: PropTypes.array
}

export default MeterTabs
